/**
 * @typedef {Object} ConnectResponseData
 * @property {string} [redirect_url] - OAuth vendor authorization URL for browser redirect
 * @property {Array} [connected] - Connected integrations collection
 * @property {Array} [unconnected] - Unconnected integrations collection
 */

/**
 * Handles the connect API response. If the response contains a redirect_url
 * (OAuth flow), redirects the browser to the vendor authorization page.
 * Otherwise returns false so the caller can handle the standard collection response.
 *
 * @param {ConnectResponseData} responseData - The API response data
 * @returns {boolean} True if a redirect was triggered, false otherwise
 */
export function handleConnectResponse(responseData) {
  if (responseData.redirect_url) {
    window.location.href = responseData.redirect_url
    return true
  }
  return false
}
